var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"OQCCharttwo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }